import type { sendSMSAsync } from "expo-sms";

const sendSmsAsync: typeof sendSMSAsync = async (addresses, message, options) => {
	return {
		result: "unknown",
	};
};
export default sendSmsAsync;
